"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * DataObjectConverter is a basic interface that handles conversion of domain objects of type T between application and external systems.
 * (e.g. WEB API or data store representation)
 *
 * @author JMe
 * @author Radek Beran
 */

var DataObjectConverter =
/*#__PURE__*/
function () {
  function DataObjectConverter() {
    _classCallCheck(this, DataObjectConverter);
  }

  _createClass(DataObjectConverter, [{
    key: "docWithOpt",

    /**
     * Assigns new key and optional value to given document and returns updated document.
     * @param doc document to update
     * @param field name of field
     * @param value value of field or null
     * @param conversion conversion function for not-null field value
     */
    value: function docWithOpt(doc, field, value, conversion) {
      doc[field] = value !== null ? conversion(value) : null;
      return doc;
    }
  }]);

  return DataObjectConverter;
}();

exports.DataObjectConverter = DataObjectConverter;